import React from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import { notification } from 'antd';
import MaterialIcon from '../../components/MaterialIcon';
import Config from '../../constants/appConfig';
import { useParams } from "react-router";

class EditDraw extends React.Component {
  state = {
    system: '',
    user: '',
    listModel: ["grok-3-mini", "grok-4-0709"],
    model: "grok-3-mini",
    listData: [],
    result: '',
    minimizedItems: {},
    showLegenda: false,
  };

  legendaPopupRef = React.createRef();

  legenda = [
    { label: 'Área total', value: '?:{area_total}' },
    { label: 'Área total aplicada', value: '?:{area_app}' },
    { label: 'Área sem aplicação registrada', value: '?:{area_nao_app}' },
    { label: 'Área aplicada dentro do perímetro planejado', value: '?:{area_app_interna}' },
    { label: 'Área com sobreposição de aplicação', value: '?:{sobreposicao}' },
    { label: 'Área aplicada fora do perímetro planejado', value: '?:{area_app_externa}' },
    { label: 'Altura', value: '?:{altura}' },
    { label: 'alvo', value: '?:{altura_alvo}' },
    { label: 'Fluxo', value: '?:{fluxo}' },
    { label: 'alvo fluxo', value: '?:{fluxo_alvo}' },
    { label: 'velocidade', value: '?:{velocidade}' },
    { label: 'alvo velocidade', value: '?:{velocidade_alvo}' },
    { label: 'altimetro', value: '?:{tem_altimetro}' },
    { label: 'fluxometro', value: '?:{tem_fluxometro}' },
    { label: 'kz', value: '?:{tem_kz}' },
    { label: 'avg kz', value: '?:{avg_kz_pos}' },
    { label: 'estacao meteorologica', value: '?:{tem_estacao}' },
    { label: 'avg vel vento', value: '?:{avg_vel_vento}' },
    { label: 'avg temp', value: '?:{avg_temp}' },
    { label: 'avg umidade', value: '?:{avg_umidade}' },
    { label: 'avg deltaT', value: '?:{avg_deltaT}' },
    { label: 'idioma', value: '?:{user_idioma}' },
  ]

  componentDidMount() {
    this.update();
    this.loadHistorico();
    document.addEventListener('mousedown', this.handleClickOutside);
  };

  componentWillUnmount() {
    // fix Warning: Can't perform a React state update on an unmounted component
    this.setState = (state, callback) => {
      return;
    };
    document.removeEventListener('mousedown', this.handleClickOutside);
  };

  handleClickOutside = event => {
    if (this.state.showLegenda && this.legendaPopupRef.current && !this.legendaPopupRef.current.contains(event.target)) {
      this.setState({ showLegenda: false });
    }
  };

  handleLegendaItemClick = (value) => {
    navigator.clipboard.writeText(value).then(() => {
    }).catch(err => {
      console.error('Falha ao copiar texto: ', err);
    });
    this.setState({ showLegenda: false });
  };

  toggleMinimize = (idx) => {
    this.setState(prevState => ({
      minimizedItems: {
        ...prevState.minimizedItems,
        [idx]: prevState.minimizedItems[idx] === undefined ? false : !prevState.minimizedItems[idx]
      }
    }));
  };

  update = () => {

  };

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  salva_ai = () => {
    let apiUrl = Config.server + '/ai_log/profile';
    let method = 'POST';

    let options = {
      method: method,
      body: JSON.stringify({
        prompt_system: this.state.system,
        prompt_user: this.state.user,
        model: this.state.model,
      }),
      headers: {
        'Content-Type': 'application/json',
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          this.loadHistorico();
          notification.success({
            message: 'Salvo com sucesso',
          });
        },
        (error) => {
          //this.setState({ progress: false });
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            console.log(error);
            this.props.link('/login');
          }
          else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  };

  loadHistorico = () => {
    let apiUrl = Config.server + '/ai_log/profiles';
    let method = 'GET';

    let options = {
      method: method,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }
    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          this.setState({ listData: result });
        },
        (error) => {
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            console.log(error);
            this.props.link('/login');
          }
          else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  };

  render() {
    const { res } = this.props;

    return (
      <div className="maxH">
        <div style={{ display: 'flex' }}>
          <MenuItem style={{ fontWeight: 'bold' }}>
            model:
          </MenuItem>
          <Select
            style={{ width: '7rem' }}
            value={this.state.model}
            onChange={this.handleChange('model')}
            inputProps={{
              id: 'type',
            }}
          >
            {this.state.listModel.map((model, index) => (
              <MenuItem key={index} value={model}>
                {model}
              </MenuItem>
            ))}
          </Select>
          <MenuItem
            style={{ fontWeight: 'bold', marginLeft: '1rem', cursor: 'pointer' }}
            onClick={() => this.setState({ showLegenda: true })}
          >
            legenda
          </MenuItem>
          <div style={{ textAlign: 'right', width: '100%' }}>
            <Button variant="contained" color="primary" onClick={this.salva_ai}>
              {'salvar'}
            </Button>
          </div>
        </div>
        {this.state.showLegenda && (
          <div
            ref={this.legendaPopupRef}
            style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              background: '#fff',
              border: '1px solid #ddd',
              borderRadius: '8px',
              padding: '2rem',
              maxHeight: '80vh',
              overflowY: 'auto',
              boxShadow: '0 4px 24px rgba(0,0,0,0.15)',
              zIndex: 9999
            }}
          >
            {this.legenda.map((item, index) => (
              <div
                key={index}
                style={{ padding: '0.4rem 0', color: '#555', fontSize: '1rem', cursor: 'pointer' }}
                onClick={() => this.handleLegendaItemClick(item.value)}
              >
                <span style={{ fontWeight: 'bold' }}>{item.label}:</span> <span>{item.value}</span>
              </div>
            ))}
          </div>
        )}
        <TextField
          id="system"
          label={res.SYSTEM}
          value={this.state.system}
          onChange={this.handleChange('system')}
          margin="normal"
          variant="outlined"
          fullWidth
          multiline
          minRows={4}
          maxRows={Infinity}
          InputProps={{
            endAdornment: <span style={{ whiteSpace: 'pre' }}>{'\n'}</span>
          }}
        />
        <TextField
          id="user"
          label={res.USER}
          value={this.state.user}
          onChange={this.handleChange('user')}
          margin="normal"
          variant="outlined"
          fullWidth
          multiline
          minRows={4}
          maxRows={Infinity}
          InputProps={{
            endAdornment: <span style={{ whiteSpace: 'pre' }}>{'\n'}</span>
          }}
        />
        {/* button to submit values */}
        <div style={{ textAlign: 'right' }}>
          <Button variant="contained" color="primary" onClick={this.loadHistorico}>
            {'atualizar'}
          </Button>
        </div>
        <div style={{ width: '100%', marginTop: '2rem' }}>
          {this.state.listData.map((item, idx) => {
            const isItemMinimized = this.state.minimizedItems[idx] !== false ;

            const renderField = (label, value, fieldKey) => {
              const isFieldMinimized = this.state.minimizedItems[fieldKey] !== false;
              const hasContent = value && value.length > 0;

              if (!hasContent) {
                return (
                  <div style={{ marginBottom: '0.5rem', display: 'flex' }}>
                    <span style={{ fontWeight: 'bold' }}>{label}:</span>
                    <div style={{ whiteSpace: 'pre-wrap', marginLeft: '1rem' }}></div>
                  </div>
                );
              }

              return (
                <div style={{ marginBottom: '0.5rem' }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ fontWeight: 'bold' }}>{label}:</span>
                    <Button size="small" style={{ marginLeft: '0.5rem', minWidth: 'auto', padding: '2px' }} onClick={() => this.toggleMinimize(fieldKey)}>
                      <MaterialIcon icon={isFieldMinimized ? 'unfold_more' : 'unfold_less'} />
                    </Button>
                  </div>
                  {isFieldMinimized ? (
                    <div style={{
                      whiteSpace: 'pre-wrap',
                      marginLeft: '1rem',
                      marginTop: '0.5rem',
                      overflow: 'hidden',
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                    }}>
                      {value}
                    </div>
                  ) : (
                    <div style={{ whiteSpace: 'pre-wrap', marginLeft: '1rem', marginTop: '0.5rem' }}>{value}</div>
                  )}
                </div>
              );
            };

            return (
              <div key={idx} style={{ border: '1px solid #ddd', borderRadius: '4px', marginBottom: '1rem', padding: '1rem', background: '#fafafa' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>
                    {item.datetime ? new Date(item.datetime).toLocaleString() : ''}
                    {isItemMinimized && item.prompt_system && (
                      <span style={{ fontWeight: 'normal', marginLeft: '1rem', color: '#555' }}>
                        {item.prompt_system.substring(0, 100)}{item.prompt_system.length > 100 ? '...' : ''}
                      </span>
                    )}
                  </div>
                  <Button onClick={() => this.toggleMinimize(idx)}>
                    <MaterialIcon icon={isItemMinimized ? 'unfold_more' : 'unfold_less'} />
                  </Button>
                </div>
                {!isItemMinimized && (
                  <>
                    <div style={{ color: '#555', marginBottom: '0.5rem' }}>
                      <span style={{ fontWeight: 'bold' }}>Model:</span> {item.model}
                    </div>
                    {renderField('System', item.prompt_system, `${idx}-system`)}
                    {renderField('User', item.prompt_user, `${idx}-user`)}

                    {Array.isArray(item.results) && item.results.length > 0 && (
                      <div style={{ marginTop: '1rem', paddingLeft: '1rem', borderLeft: '3px solid #eee' }}>
                        <div style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>Results:</div>
                        {item.results.map((result, rIdx) => (
                          <div key={rIdx} style={{ marginBottom: '1rem', padding: '0.5rem', background: '#f5f5f5', borderRadius: '3px' }}>
                            <div style={{ color: '#555', marginBottom: '0.5rem' }}>
                              <span style={{ fontWeight: 'bold' }}>Datetime:</span> {result.datetime ? new Date(result.datetime).toLocaleString() : ''}
                            </div>
                            {result.company_name && <div style={{ color: '#555', marginBottom: '0.5rem' }}>
                              <span style={{ fontWeight: 'bold' }}>Company:</span> {result.company_name}
                            </div>}
                            {result.job_title && <div style={{ color: '#555', marginBottom: '0.5rem' }}>
                              <span style={{ fontWeight: 'bold' }}>Job Title:</span> {result.job_title}
                            </div>}
                            {renderField('Content', result.content, `${idx}-${rIdx}-content`)}
                            {renderField('Reasoning', result.reasoning, `${idx}-${rIdx}-reasoning`)}
                          </div>
                        ))}
                      </div>
                    )}
                  </>
                )}
              </div>
            )
          })}
        </div>
      </div>
    );
  };
}

const TextFields1 = EditDraw;

const Box = (props) => {
  const { link, res } = props;
  let { local } = useParams();
  return (
    <div className="rowForm maxH">
      <TextFields1 link={link} local={local} res={res} />
    </div>);
}

export default Box;

